import { WhatsappLogo, Phone } from "@phosphor-icons/react";
import { toast } from "sonner";
import { trackWhatsAppClick, trackCallClick } from "@/lib/track";

const PHONE_DISPLAY = "+91-9819998036";
const PHONE_TEL = "+919819998036";
const WHATSAPP_NUMBER = "919819998036";
const WA_MESSAGE = encodeURIComponent(
  "Hi Venkataramanan, I came across Gurukul of Ramana and would like to discuss "
);

function isMobile() {
  if (typeof navigator === "undefined") return false;
  return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}

function istHour() {
  // Current hour (0-23) in India Standard Time
  const h = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Kolkata",
    hour: "2-digit",
    hour12: false,
  }).format(new Date());
  return parseInt(h, 10) % 24;
}

function withinCallHours() {
  const h = istHour();
  return h >= 8 && h < 21; // 8:00 AM to 9:00 PM IST
}

export default function FloatingContactButtons() {
  function handleCall(e) {
    trackCallClick("floating_button");
    if (!withinCallHours()) {
      e.preventDefault();
      toast.info(
        "Our phone lines are open 8:00 AM – 9:00 PM IST. Please call during these hours — or message us anytime on WhatsApp."
      );
      return;
    }
    if (isMobile()) return; // let default tel: link handle it
    e.preventDefault();
    try {
      navigator.clipboard.writeText(PHONE_DISPLAY);
      toast.success(`Phone number ${PHONE_DISPLAY} copied. Use your phone to call.`);
    } catch {
      toast.info(`Call us at ${PHONE_DISPLAY}`);
    }
  }

  return (
    <div
      data-testid="floating-contact-buttons"
      className="fixed bottom-6 left-6 z-30 flex flex-col gap-3"
    >
      <a
        data-testid="floating-whatsapp"
        href={`https://wa.me/${WHATSAPP_NUMBER}?text=${WA_MESSAGE}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        onClick={() => trackWhatsAppClick("floating_button")}
        className="group relative"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-20 animate-ping group-hover:hidden" />
        <span className="relative flex items-center gap-2 h-14 px-5 rounded-full border border-[#25D366]/50 bg-[#061324]/75 backdrop-blur-md text-[#25D366] shadow-[0_15px_40px_-12px_rgba(6,19,36,0.8)] transition-colors duration-300 hover:bg-[#25D366] hover:text-[#061324]">
          <WhatsappLogo size={22} weight="fill" />
          <span className="text-sm tracking-wide hidden sm:inline">WhatsApp</span>
        </span>
      </a>
      <a
        data-testid="floating-call"
        href={`tel:${PHONE_TEL}`}
        onClick={handleCall}
        aria-label={`Call ${PHONE_DISPLAY}`}
        title={`${PHONE_DISPLAY} · 8 AM–9 PM IST`}
        className="group relative"
      >
        <span className="relative flex items-center gap-2 h-14 px-5 rounded-full border border-[#C6A87C]/50 bg-[#061324]/75 backdrop-blur-md text-[#C6A87C] shadow-[0_15px_40px_-12px_rgba(6,19,36,0.8)] transition-colors duration-300 hover:bg-[#C6A87C] hover:text-[#061324]">
          <Phone size={20} weight="fill" />
          <span className="text-sm tracking-wide hidden sm:inline">Call us</span>
        </span>
      </a>
      <span
        data-testid="call-hours-label"
        className="ml-1 px-2 py-1 bg-[#061324]/80 backdrop-blur-md border border-[#C6A87C]/25 text-[#C6A87C] text-[10px] font-mono-tech uppercase tracking-[0.14em] w-fit"
      >
        Call · 8 AM–9 PM IST
      </span>
    </div>
  );
}
